<template>
  <v-container :class="containerClass" fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          v-model="selectedItems"
          :headers="headers"
          :items="itemList.data"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="itemList.meta.total"
          :footer-props="defaultDataTableFooterProps"
          item-key="id"
          show-select
        >
          <template #top>
            <v-sheet>
              <v-container fluid class="pa-4">
                <v-row align="center">
                  <v-col md="4" cols="12">
                    <h2>Invoice List</h2>
                  </v-col>
                  <v-col md="8" cols="12" class="text-right">
                    <v-menu offset-y>
                      <template #activator="{ on, attrs }">
                        <v-btn color="info" v-bind="attrs" v-on="on">
                          Actions
                          <v-icon :small="$vuetify.breakpoint.mobile" right>
                            mdi-menu-down
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          :href="
                            $route('invoices.download-report', {
                              ...downloadReportQueryParams,
                            })
                          "
                        >
                          <v-icon small left>mdi-cloud-download</v-icon>
                          <v-list-item-title>
                            Download Report (Excel)
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          :href="
                            $route('invoices.download-multi-pdf', {
                              ...downloadAllQueryParams,
                            })
                          "
                        >
                          <v-icon small left>mdi-cloud-download</v-icon>
                          <v-list-item-title>
                            Download Multi-PDF
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          :disabled="selectedItems.length === 0"
                          @click="showUpdateBulkDialog"
                        >
                          <v-icon small left>mdi-pencil</v-icon>
                          <v-list-item-title> Bulk Update </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn
                      v-if="hasPermission('invoices.create')"
                      color="primary"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      :href="$route('invoices.create')"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left>
                        mdi-plus
                      </v-icon>
                      Tambah
                    </v-btn>
                    <v-btn
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      @click="showFilters = !showFilters"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-filter</v-icon
                      >{{ showFilters ? 'Hide' : 'Show' }} Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
            <v-divider></v-divider>
            <v-expand-transition>
              <v-sheet v-show="showFilters" color="grey lighten-5">
                <v-container fluid class="pa-4">
                  <!-- Row 1 -->
                  <v-row align="center">
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Invoice No.</div>
                      <v-text-field
                        v-model="filters.code"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Invoice No."
                        hide-details
                        dense
                        clearable
                        @blur="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Student ID</div>
                      <v-text-field
                        v-model="filters.student_code"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Student ID"
                        hide-details
                        dense
                        clearable
                        @blur="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Student</div>
                      <v-autocomplete
                        v-model="filters.student_id"
                        :items="students"
                        item-text="name"
                        item-value="id"
                        :loading="isStudentListLoading"
                        :search-input.sync="search.student"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Student"
                        hide-details
                        dense
                        clearable
                        cache-items
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Teacher</div>
                      <v-autocomplete
                        v-model="filters.teacher_id"
                        :items="teachers"
                        item-text="name"
                        item-value="id"
                        :loading="isTeacherListLoading"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Teacher"
                        hide-details
                        dense
                        clearable
                        cache-items
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Payment Method</div>
                      <v-select
                        v-model="filters.payment_method_id"
                        :items="paymentMethods"
                        item-text="name"
                        item-value="id"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Payment Method"
                        hide-details
                        dense
                        clearable
                        :loading="isPaymentMethodsLoading"
                        @change="getListData"
                        @click:clear="getListData"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Deposit</div>
                      <v-select
                        v-model="filters.deposit"
                        :items="depositOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Deposit"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Order ID</div>
                      <v-text-field
                        v-model="filters.subscription_order_code"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Order ID"
                        hide-details
                        dense
                        clearable
                        @blur="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Subs. Package</div>
                      <v-autocomplete
                        v-model="filters.subscription_package_id"
                        :items="subscriptionPackages"
                        item-text="name"
                        item-value="id"
                        :loading="isSubscriptionPackageListLoading"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Subscription Package"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Class Type</div>
                      <v-select
                        v-model="filters.classroom_type"
                        :items="classroomTypeOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Class Type"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Lesson Plan</div>
                      <v-select
                        v-model="filters.lesson_plan_id"
                        :items="lessonPlans"
                        item-text="name"
                        item-value="id"
                        :loading="isLessonPlanListLoading"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Lesson Plan"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Status</div>
                      <v-select
                        v-model="filters.status"
                        :items="statusOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Status"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Status Date</div>
                      <date-picker
                        v-model="filters.status_date"
                        placeholder="Paid / Canceled date"
                        value-type="format"
                        type="date"
                        range
                        class="mx-datepicker--dense mx-datepicker--hide-details"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Issue Date</div>
                      <date-picker
                        v-model="filters.issue_date"
                        value-type="format"
                        type="date"
                        range
                        class="mx-datepicker--dense mx-datepicker--hide-details"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Due Date</div>
                      <date-picker
                        v-model="filters.due_date"
                        value-type="format"
                        type="date"
                        range
                        class="mx-datepicker--dense mx-datepicker--hide-details"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Term</div>
                      <v-text-field
                        v-model="filters.term"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Term"
                        hide-details
                        dense
                        clearable
                        @blur="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Month</div>
                      <v-text-field
                        v-model="filters.month"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Month"
                        hide-details
                        dense
                        clearable
                        @blur="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Period Start</div>
                      <date-picker
                        v-model="filters.period_start_date"
                        value-type="format"
                        type="date"
                        class="mx-datepicker--dense mx-datepicker--hide-details"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="label mb-2">Period End</div>
                      <date-picker
                        v-model="filters.period_end_date"
                        value-type="format"
                        type="date"
                        class="mx-datepicker--dense mx-datepicker--hide-details"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div class="label mb-2">Label</div>
                      <v-select
                        v-model="filters.item_category_id"
                        :items="itemCategories"
                        item-text="label"
                        item-value="id"
                        multiple
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Label"
                        hide-details
                        dense
                        clearable
                        :loading="isItemCategoriesLoading"
                        @change="getListData"
                        @click:clear="getListData"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
              </v-sheet>
            </v-expand-transition>
          </template>
          <template #[`item.code`]="{ item }">
            <a
              :href="$route('invoices.update', item.id)"
              target="_blank"
              class="black--text"
            >
              <strong>{{ item.code }}</strong>
            </a>
          </template>
          <template #[`item.student`]="{ item }">
            <div>{{ item.student.name }}</div>
            <div class="text-caption">
              {{ item.student.code }}
            </div>
          </template>
          <template #[`item.teacher`]="{ item }">
            {{ item.teacher?.name ?? '-' }}
          </template>
          <template #[`item.term`]="{ item }">
            {{ item.term ?? '-' }}
          </template>
          <template #[`item.subscription_order`]="{ item }">
            <div v-if="item.subscription_order != null">
              <div>
                <a
                  :href="
                    $route(
                      'subscription-orders.update',
                      item.subscription_order.id
                    )
                  "
                  target="_blank"
                  class="black--text"
                >
                  {{ item.subscription_order.code }}
                </a>
              </div>
              <v-chip
                v-if="item.subscription_order.is_trial"
                small
                color="warning"
                dark
                class="mb-1"
              >
                <strong>Trial</strong>
              </v-chip>
              <v-chip
                v-if="item.subscription_order.deposit_amount"
                small
                color="info"
                dark
                class="mb-1"
              >
                <strong>Deposit</strong>
              </v-chip>
            </div>
            <div v-else>-</div>
          </template>
          <!-- <template #[`item.subscription_package`]="{ item }">
            {{
              item.subscription_order
                ? item.subscription_order.subscription_package.name
                : '-'
            }}
          </template>
          <template #[`item.lesson_plan`]="{ item }">
            {{
              item.subscription_order
                ? item.subscription_order.subscription_package.lesson_plan.name
                : '-'
            }}
          </template>
          <template #[`item.classroom_type`]="{ item }">
            {{
              item.subscription_order
                ? classroomTypeProps(
                    item.subscription_order.subscription_package.classroom_type,
                    'text'
                  )
                : '-'
            }}
          </template> -->
          <template #[`item.total_billed_amount`]="{ item }">
            {{ `IDR ${formatNumber(item.total_billed_amount)}` }}
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip
              :color="invoiceStatusProps(item.status, 'color')"
              small
              dark
            >
              <strong>
                {{ invoiceStatusProps(item.status, 'text') }}
              </strong>
            </v-chip>
          </template>
          <template #[`item.status_date`]="{ item }">
            <div v-if="item.status === 'PAID'">
              {{
                item.paid_date ? formatDate(item.paid_date, 'DD MMM YYYY') : '-'
              }}
            </div>
            <div v-else-if="item.status === 'CANCELED'">
              {{
                item.canceled_date
                  ? formatDate(item.canceled_date, 'DD MMM YYYY')
                  : '-'
              }}
            </div>
            <div v-else>-</div>
          </template>
          <template #[`item.issue_date`]="{ item }">
            {{
              item.issue_date ? formatDate(item.issue_date, 'DD MMM YYYY') : '-'
            }}
          </template>
          <template #[`item.due_date`]="{ item }">
            {{ item.due_date ? formatDate(item.due_date, 'DD MMM YYYY') : '-' }}
          </template>
          <template #[`item.period`]="{ item }">
            <div v-if="item.period_start_date && item.period_end_date">
              {{
                formatDateRangeDisplay(
                  item.period_start_date,
                  item.period_end_date
                )
              }}
            </div>
            <div v-else>-</div>
          </template>
          <template #[`item.payment`]="{ item }">
            <div v-if="!!item.payment_method">
              <div class="text-body-2 mb-1">{{ item.payment_method.name }}</div>
              <div class="text-caption">
                {{ item.payment_method.account_name }}
              </div>
            </div>
            <div v-else>-</div>
          </template>
          <template #[`item.action`]="{ item }">
            <v-menu offset-y>
              <template #activator="{ on, attrs }">
                <v-btn icon color="gray" v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <template v-for="(action, i) in generateRowActions(item)">
                  <v-list-item
                    v-if="hasPermission(action.permission)"
                    :key="i"
                    :href="action.route"
                    @click="action.onClick"
                  >
                    <v-icon small left>{{ action.icon }}</v-icon>
                    <v-list-item-title>{{ action.title }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <invoice-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :invoice="deleteDialog.item"
      @delete="getListData"
    >
    </invoice-delete-dialog>
    <invoice-update-bulk-dialog
      v-if="updateBulkDialog.show"
      v-model="updateBulkDialog.show"
      :invoices="selectedItems"
      @submit="getListData"
    >
    </invoice-update-bulk-dialog>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import constant from '@/constant'
import InvoiceDeleteDialog from '@components/Invoice/DeleteDialog'
import InvoiceUpdateBulkDialog from '@components/Invoice/UpdateBulkDialog'
import { ListParams } from '@/models'
import utils from '@/utils'

export default {
  name: 'Invoice',
  components: {
    InvoiceDeleteDialog,
    InvoiceUpdateBulkDialog,
  },
  layout: LayoutDashboard,
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      showFilters: true,
      filters: {
        code: null,
        student_code: null,
        student_id: null,
        teacher_id: null,
        subscription_order_code: null,
        subscription_package_id: null,
        classroom_type: null,
        lesson_plan_id: null,
        status: null,
        deposit: null,
        issue_date: [],
        due_date: [],
        status_date: [],
        term: null,
        month: null,
        period_start_date: null,
        period_end_date: null,
        item_category_id: [],
        // paid_date: [],
        // canceled_date: [],
        // created_at: [],
        // updated_at: [],
        payment_method_id: null,
      },
      deleteDialog: {
        show: false,
        item: null,
      },
      updateBulkDialog: {
        show: false,
      },
      search: {
        student: null,
      },
      initialized: false,
      selectedItems: [],
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'invoice/list',
      isLoading: 'invoice/isListLoading',
      studentList: 'student/searchList',
      isStudentListLoading: 'student/isSearchListLoading',
      lessonPlanList: 'lessonPlan/list',
      isLessonPlanListLoading: 'lessonPlan/isListLoading',
      subscriptionPackageList: 'subscriptionPackage/list',
      isSubscriptionPackageListLoading: 'subscriptionPackage/isListLoading',
      listParams: 'invoice/listParams',
      teacherList: 'teacher/searchList',
      isTeacherListLoading: 'teacher/isSearchListLoading',
      paymentMethods: 'invoice/paymentMethods',
      isPaymentMethodsLoading: 'invoice/isPaymentMethodsLoading',
      isItemCategoriesLoading: 'invoice/isItemCategoriesLoading',
      itemCategories: 'invoice/itemCategories',
    }),
    statusOptions() {
      return constant.invoiceStatusOptions
    },
    depositOptions() {
      return constant.depositOptions
    },
    classroomTypeOptions() {
      return constant.classroomTypeOptions
    },
    students() {
      return this.studentList.data
    },
    lessonPlans() {
      return this.lessonPlanList.data
    },
    subscriptionPackages() {
      return this.subscriptionPackageList.data
    },
    teachers() {
      return this.teacherList.data
    },
    headers() {
      return [
        { text: 'ID', value: 'code', sortable: false },
        {
          text: 'Order ID',
          value: 'subscription_order',
          sortable: false,
        },
        ...(this.isStudentAccount === false
          ? [{ text: 'Student', value: 'student', sortable: false }]
          : []),
        { text: 'Term', value: 'term', sortable: false },
        { text: 'Teacher', value: 'teacher', sortable: false },
        { text: 'Issue Date', value: 'issue_date' },
        { text: 'Due Date', value: 'due_date' },
        { text: 'Period', value: 'period', sortable: false },
        {
          text: 'Total Billed Amount',
          value: 'total_billed_amount',
          sortable: false,
        },
        { text: 'Payment Info', value: 'payment', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Status Date', value: 'status_date', sortable: false },
        { text: 'Action', value: 'action', sortable: false, align: 'center' },
      ]
    },
    downloadAllQueryParams() {
      const sortParam = utils.toServerSideSort(this.options)
      return { ...this.filters, sort: sortParam }
    },
    downloadReportQueryParams() {
      const { status_date, ...request } = this.filters
      if (request.status === 'PAID') {
        request.paid_date = status_date ?? []
      } else if (request.status === 'CANCELED') {
        request.canceled_date = status_date ?? []
      }
      return request
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
    'search.student': function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        console.log(
          `watch search student. newVal: ${newVal}, oldVal: ${oldVal}`
        )
        this.debouncedSearchStudentList()
      }
    },
    'filters.student_id': function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.getTeacherList({
          private_student_id: [newVal],
          status: ['ACTIVE'],
        })
      }
    },
  },
  created() {
    this.init()
    this.debouncedSearchStudentList = _.debounce(this.searchStudentList, 500)
  },
  methods: {
    ...mapActions({
      getItemList: 'invoice/getList',
      getSubscriptionPackageList: 'subscriptionPackage/getList',
      getLessonPlanList: 'lessonPlan/getList',
      getStudentList: 'student/search',
      getTeacherList: 'teacher/search',
      getPaymentMethods: 'invoice/getPaymentMethods',
      getItemCategories: 'invoice/getItemCategories',
    }),
    ...mapMutations({
      setListParams: 'invoice/setListParams',
      setListParamOptions: 'invoice/setListParamOptions',
    }),
    async init() {
      if (this.listParams) {
        _.merge(this.filters, this.listParams.filters)
        _.merge(this.options, this.listParams.options)
        _.merge(this.search, this.listParams.search)
      }
      if (this.isStudentAccount) {
        this.filters.student_id = this.authUser.account_id
      }

      await Promise.all([
        this.getLessonPlanList(),
        this.getSubscriptionPackageList(),
        this.getTeacherList({
          status: ['ACTIVE'],
        }),
        this.getPaymentMethods(),
        this.getItemCategories(),
        ...(!this.isStudentAccount && this.search.student
          ? [this.searchStudentList()]
          : []),
      ])
      this.initialized = true
    },
    // toDownloadAllQueryParams() {
    //   const sortOpts = utils.toServerSideSort(this.options)
    //   return { ...this.filters, ...sortOpts }
    // },
    getListData() {
      const listParams = new ListParams(this.filters, this.options, this.search)
      const { status_date, ...request } = utils.toServerSideQuery(listParams)
      if (request.status === 'PAID') {
        request.paid_date = status_date ?? []
      } else if (request.status === 'CANCELED') {
        request.canceled_date = status_date ?? []
      }
      this.getItemList(request)
      this.setListParams(listParams)
    },
    showDeleteDialog(item) {
      this.deleteDialog.item = item
      this.deleteDialog.show = true
    },
    async searchStudentList() {
      if (this.search.student) {
        await this.getStudentList({ search: this.search.student })
      }
    },
    generateRowActions(item) {
      return [
        {
          permission: 'invoices.view',
          route: this.$route('invoices.download-pdf', item.id),
          onClick: () => {},
          title: 'Download',
          icon: 'mdi-cloud-download',
        },
        {
          permission: 'invoices.view',
          route: this.$route('invoices.detail', item.id),
          onClick: () => {},
          title: 'View Detail',
          icon: 'mdi-eye',
        },
        {
          permission: 'invoices.update',
          route: this.$route('invoices.update', item.id),
          onClick: () => {},
          title: 'Edit',
          icon: 'mdi-pencil',
        },
        {
          permission: 'invoices.delete',
          route: null,
          onClick: () => this.showDeleteDialog(item),
          title: 'Delete',
          icon: 'mdi-delete-forever',
        },
      ]
    },
    showUpdateBulkDialog() {
      this.updateBulkDialog.show = true
    },
  },
}
</script>
